interface RiskBadgeProps {
  level: string;
  size?: 'sm' | 'md' | 'lg';
}

const riskConfig: Record<string, { color: string; bg: string; label: string }> = {
  green: {
    color: 'text-green-800',
    bg: 'bg-green-100',
    label: '低风险',
  },
  yellow: {
    color: 'text-yellow-800',
    bg: 'bg-yellow-100',
    label: '中风险',
  },
  orange: {
    color: 'text-orange-800',
    bg: 'bg-orange-100',
    label: '高风险',
  },
  red: {
    color: 'text-red-800',
    bg: 'bg-red-100',
    label: '严重风险',
  },
  black: {
    color: 'text-white',
    bg: 'bg-gray-900',
    label: '调查阈值',
  },
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-2 text-base',
};

function RiskBadge({ level, size = 'md' }: RiskBadgeProps) {
  const config = riskConfig[level] || riskConfig.green;

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${config.bg} ${config.color} ${sizeClasses[size]}`}
    >
      {config.label}
    </span>
  );
}

export default RiskBadge;
